import axios from 'axios';
import { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';

interface IMeetingProps {
  show: boolean;
  onClose: () => void;
}

const Meeting = ({ show = false, onClose = () => {} }: IMeetingProps) => {
  const [name, setName] = useState<string>('');
  const [date, setDate] = useState<string>('');
  const [answerBefore, setAnswerBefore] = useState<string>('');
  const [antenna, setAntenna] = useState<string>('');
  const [room, setRoom] = useState<string>('');
  const [site, setSite] = useState<string>('');
  const [street, setStreet] = useState<string>('');
  const [city, setCity] = useState<string>('');

  const handleCancel = () => {
    setName('');
    setDate('');
    setAnswerBefore('');
    setAntenna('');
    setRoom('');
    setSite('');
    setStreet('');
    setCity('');
    onClose();
  };

  const handleSave = () => {
    axios
      .post('/api/meeting', {
        name,
        event_date: date,
        answer_before: answerBefore,
        antenna,
        room,
        site,
        street,
        city,
      })
      .then(() => {
        handleCancel();
      });
  };

  return (
    <Modal show={show} onHide={handleCancel}>
      <Modal.Header closeButton>
        <Modal.Title>New meeting</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group>
            <Form.Label>Name</Form.Label>
            <Form.Control
              name="name"
              type="text"
              value={name}
              onChange={(i) => setName(i.target.value)}
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>Antenna</Form.Label>
            <Form.Control
              name="antenna"
              type="text"
              value={antenna}
              onChange={(i) => setAntenna(i.target.value)}
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>Date</Form.Label>
            <Form.Control
              name="date"
              type="datetime-local"
              value={date}
              onChange={(i) => setDate(i.target.value)}
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>Answer before</Form.Label>
            <Form.Control
              name="answer_before"
              type="date"
              value={answerBefore}
              onChange={(i) => setAnswerBefore(i.target.value)}
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>Room</Form.Label>
            <Form.Control
              name="room"
              type="text"
              value={room}
              onChange={(i) => setRoom(i.target.value)}
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>Site</Form.Label>
            <Form.Control
              name="site"
              type="text"
              value={site}
              onChange={(i) => setSite(i.target.value)}
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>Street</Form.Label>
            <Form.Control
              name="street"
              type="text"
              value={street}
              onChange={(i) => setStreet(i.target.value)}
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>City</Form.Label>
            <Form.Control
              name="city"
              type="text"
              value={city}
              onChange={(i) => setCity(i.target.value)}
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleCancel}>
          Close
        </Button>
        <Button variant="primary" onClick={handleSave}>
          Save
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default Meeting;
